import React from "react";
import Dashboard from "../../@Components/Dashboard";
import { Col, Content, Grid, Row } from "rsuite";
import DataSources from "../../@Components/Data/DataSources";

const DataSourcesPage: React.FC = () => {
  return (
    <Dashboard>
      <Grid fluid>
        <Row className="show-grid">
          <Col className="content-card chart" xs={24}>
            <Content style={{ height: "fit-content" }}>
              <DataSources />
            </Content>
          </Col>
        </Row>
      </Grid>
    </Dashboard>
  );
};

export default DataSourcesPage;
